export enum SidebarInterfaceTypesEnum {
  TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR',
}
